import { Controller } from "@hotwired/stimulus"
import {ColorisManager} from "../lib/coloris_manager";

export default class extends Controller {
  connect() {
    this.setupSpacingControls()
    this.setupColorControls()
  }

  setupSpacingControls() {
    // Handle spacing increment/decrement buttons
    this.element.querySelectorAll('.spacing-increment, .spacing-decrement').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const isIncrement = button.classList.contains('spacing-increment')
        const direction = button.getAttribute('data-direction')
        const spacingControl = button.closest('.spacing-control')
        const input = spacingControl.querySelector(`.spacing-input[data-direction="${direction}"]`)
        const valueSpan = input.previousElementSibling

        let value = parseInt(input.value) || 0

        if (isIncrement && value < 5) {
          value++
        } else if (!isIncrement && value > 0) {
          value--
        }

        input.value = value
        valueSpan.textContent = value
      })
    })
  }

  setupColorControls() {
    this.colorisManager = new ColorisManager(this.element, { parent: '.modal-body' })
  }
}
